import { FonteIdadeGestacionalEnum, Period } from 'graphql/types.generated'

export interface AcompanhamentoPuerperioInformacoes {
  duracaoPuerperio: Period
  dataInicioGestacao?: LocalDate
  puerperioAtivo: boolean
  acompanhamentoAtivo: boolean
  dataDesfechoGestacao?: Date
  fonteIdadeGestacional?: FonteIdadeGestacionalEnum
}

export const DIAS_GESTACAO_LIMITE = 294
export const DIAS_PUERPERIO = 42
export const DIAS_MODULO_ATIVO = 90

export enum TipoPuerperio {
  IMEDIATO = 'Imediato',
  TARDIO = 'Tardio',
}
